import { useEffect, useState } from "react";

/**
 * `value`, once it has stopped changing for `delayMs` — what a search field
 * sends to the server, so a request goes out per pause rather than per key.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timeout = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(timeout);
  }, [value, delayMs]);

  return debounced;
}
